import { trpc } from '@client/utils/trpc';
import { Alert, Card, CardContent, CardProps, Skeleton, Typography } from '@mui/material';
import { BarChart } from '@mui/x-charts';

export type PeerCountChartCardProps = CardProps & {
  chain: string | null;
  showOffline?: boolean;
};

export const PeerCountChartCard = ({ chain, showOffline, ...rest }: PeerCountChartCardProps) => {
  const { data, status, error } = trpc.chart.peerCount.useQuery({
    chain,
    showOffline,
  });

  return (
    <Card {...rest}>
      <CardContent>
        <Typography variant={'h5'}>{'Peers'}</Typography>

        {status === 'success' ? (
          <BarChart
            xAxis={[{ data: data.map((item) => item.peerCount) }]}
            series={[{ data: data.map((item) => item.count) }]}
            yAxis={[
              {
                min: 0,
              },
            ]}
            height={256}
            hideLegend
          />
        ) : status === 'error' ? (
          <Alert severity={'error'}>{error.message}</Alert>
        ) : (
          <Skeleton variant={'rounded'} height={256} />
        )}
      </CardContent>
    </Card>
  );
};
